import 'twin.macro';

const TryDemoTimeLine = ({ duration = 9000, resetKey }) => {
  return (
    <>
      <style>{`
        @keyframes trydemo-progress {
          from { width: 0%; }
          to   { width: 100%; }
        }
      `}</style>
      <div
        tw="absolute bottom-4 left-1/2 -translate-x-1/2 md:w-[90%] w-[15%] h-[18px]"
        style={{
          background: 'rgba(255,255,255,0.55)',
          backdropFilter: 'blur(8px)',
          borderRadius: '999px',
          padding: '5px 6px',
          boxShadow: '0 4px 18px rgba(0,0,0,0.13)',
        }}
      >
        <div
          key={resetKey}
          style={{
            background: '#8DA12B',
            height: '100%',
            borderRadius: '999px',
            width: '0%',
            animation: `trydemo-progress ${duration}ms linear forwards`,
          }}
        />
      </div>
    </>
  );
};

export default TryDemoTimeLine;
